import { SessionBookerIframe } from '../components';
import { Box } from '@chakra-ui/react';

export const BookLiveSessionNow = () => (
  <Box width="100%" height="100%">
    <SessionBookerIframe width="100%" height="100%" />
  </Box>
);
